import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDynamicFormAutocomplete, LazyDynamicFormCheckList, LazyDynamicFormDatePicker, LazyDynamicFormImageInput, LazyDynamicFormInput, LazyDynamicFormInputPrefix, LazyDynamicFormListBox, LazyDynamicFormSelect, LazyDynamicFormSelectionList, LazyDynamicFormTextArea, LazyAccountMenu, LazyBaseFormAccordion, LazyBaseFormAutocomplete, LazyBaseFormCheckbox, LazyBaseFormChooser, LazyBaseFormColor, LazyBaseFormDivider, LazyBaseFormEditor, LazyBaseFormImage, LazyBaseFormInput, LazyBaseFormInvoiceDisplay, LazyBaseFormLinkList, LazyBaseFormList, LazyBaseFormOptionInput, LazyBaseFormRepeater, LazyBaseFormSelect, LazyBaseFormSlot, LazyBaseFormTextarea, LazyBaseFormTime, LazyBaseFormTranslations, LazyBaseFormValueDisplay, LazyBaseForm, LazyBlockEditor, LazyBlockImageForm, LazyBlockImage, LazyBlockTextForm, LazyBlockText, LazyBlockTextImageForm, LazyBlockTextImage, LazyFeestFietsLogo, LazyPanelAbsence, LazyPanelBookingForm, LazyPanelBookingProposal, LazyPanelCalendarEntry, LazyPanelEditPackage, LazyPanelPlanner, LazySidebarFooter, LazySidebarHeader, LazyToolbarLogo, LazyTairoLogo, LazyTairoLogoText, LazyTairoToaster, LazyTairoTocAnchor, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["DynamicFormAutocomplete", LazyDynamicFormAutocomplete],
["DynamicFormCheckList", LazyDynamicFormCheckList],
["DynamicFormDatePicker", LazyDynamicFormDatePicker],
["DynamicFormImageInput", LazyDynamicFormImageInput],
["DynamicFormInput", LazyDynamicFormInput],
["DynamicFormInputPrefix", LazyDynamicFormInputPrefix],
["DynamicFormListBox", LazyDynamicFormListBox],
["DynamicFormSelect", LazyDynamicFormSelect],
["DynamicFormSelectionList", LazyDynamicFormSelectionList],
["DynamicFormTextArea", LazyDynamicFormTextArea],
["AccountMenu", LazyAccountMenu],
["BaseFormAccordion", LazyBaseFormAccordion],
["BaseFormAutocomplete", LazyBaseFormAutocomplete],
["BaseFormCheckbox", LazyBaseFormCheckbox],
["BaseFormChooser", LazyBaseFormChooser],
["BaseFormColor", LazyBaseFormColor],
["BaseFormDivider", LazyBaseFormDivider],
["BaseFormEditor", LazyBaseFormEditor],
["BaseFormImage", LazyBaseFormImage],
["BaseFormInput", LazyBaseFormInput],
["BaseFormInvoiceDisplay", LazyBaseFormInvoiceDisplay],
["BaseFormLinkList", LazyBaseFormLinkList],
["BaseFormList", LazyBaseFormList],
["BaseFormOptionInput", LazyBaseFormOptionInput],
["BaseFormRepeater", LazyBaseFormRepeater],
["BaseFormSelect", LazyBaseFormSelect],
["BaseFormSlot", LazyBaseFormSlot],
["BaseFormTextarea", LazyBaseFormTextarea],
["BaseFormTime", LazyBaseFormTime],
["BaseFormTranslations", LazyBaseFormTranslations],
["BaseFormValueDisplay", LazyBaseFormValueDisplay],
["BaseForm", LazyBaseForm],
["BlockEditor", LazyBlockEditor],
["BlockImageForm", LazyBlockImageForm],
["BlockImage", LazyBlockImage],
["BlockTextForm", LazyBlockTextForm],
["BlockText", LazyBlockText],
["BlockTextImageForm", LazyBlockTextImageForm],
["BlockTextImage", LazyBlockTextImage],
["FeestFietsLogo", LazyFeestFietsLogo],
["PanelAbsence", LazyPanelAbsence],
["PanelBookingForm", LazyPanelBookingForm],
["PanelBookingProposal", LazyPanelBookingProposal],
["PanelCalendarEntry", LazyPanelCalendarEntry],
["PanelEditPackage", LazyPanelEditPackage],
["PanelPlanner", LazyPanelPlanner],
["SidebarFooter", LazySidebarFooter],
["SidebarHeader", LazySidebarHeader],
["ToolbarLogo", LazyToolbarLogo],
["TairoLogo", LazyTairoLogo],
["TairoLogoText", LazyTairoLogoText],
["TairoToaster", LazyTairoToaster],
["TairoTocAnchor", LazyTairoTocAnchor],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
